<script setup lang="ts">
const userStore = useUserStore()
const { isLogin } = storeToRefs(userStore)

const buyModalRef = ref()
const loginModalNewRef = ref()
const LoginPopTipsRef = ref()
const postViewRef = ref()
const postViewPhoneRef = ref()
const globalAlertRef = ref()
const uploadLeaveConfirmModalRef = ref()
const globalMaskRef = ref()
const musicPlayerRef = ref()
const welcomeRef = ref()
const getRewardsRef = ref()
const insufficientFundsRef = ref()
const hasInit = ref(false)
const leaveConfirmModalRef = ref()
const payIframeRef = ref()
const CreditCardModalRef = ref()
const topUpFirstRef = ref()
const paySuccessRef = ref()
const payTopUpRef = ref()
const paypalModalRef = ref()
const payMaskRef = ref()

const PayMaskAsync = defineAsyncComponent({
  loader: () => import('@/components/Common/PayMask.vue'),
  delay: 10000,
})

const PSWPPostViewPhoneAsync = defineAsyncComponent({
  loader: () => import('@/components/Post/PSWPPostViewPhone.vue'),
  delay: 500,
})

const LoginModalNewAsync = defineAsyncComponent({
  loader: () => import('@/components/LoginModal/LoginModalNew.vue'),
  delay: 500,
})

const LoginPopTipsAsync = defineAsyncComponent({
  loader: () => import('@/components/LoginModal/LoginPopTips.vue'),
  delay: 500,
})

const BuyModalAsync = defineAsyncComponent({
  loader: () => import('@/components/BuyModal/index.vue'),
  delay: 500,
})

const MusicPlayerAsync = defineAsyncComponent({
  loader: () => import('@/components/MusicPlayer/index.vue'),
  delay: 10000,
})

const PostViewAsync = defineAsyncComponent({
  loader: () => import('@/components/Post/PostView.vue'),
  delay: 500,
})

const UploadLeaveConfirmModalAsync = defineAsyncComponent({
  loader: () => import('@/components/Common/UploadLeaveConfirmModal.vue'),
  delay: 10000,
})

const InsufficientFundsAsync = defineAsyncComponent({
  loader: () => import('@/components/BuyModal/InsufficientFunds.vue'),
  delay: 10000,
})

const LeaveConfirmModalAsync = defineAsyncComponent({
  loader: () => import('@/components/Common/LeaveConfirmModal.vue'),
  delay: 10000,
})

const PayIframeAsync = defineAsyncComponent({
  loader: () => import('@/components/BuyModal/PayIframe.vue'),
  delay: 10000,
})

const CreditCardModalAsync = defineAsyncComponent({
  loader: () => import('@/components/BuyModal/CreditCardModal.vue'),
  delay: 10000,
})

const TopUpFirstAsync = defineAsyncComponent({
  loader: () => import('@/components/BuyModal/TopUpFirst.vue'),
  delay: 10000,
})

const PaySuccessAsync = defineAsyncComponent({
  loader: () => import('@/components/BuyModal/PaySuccess.vue'),
  delay: 10000,
})

const PayTopUpAsync = defineAsyncComponent({
  loader: () => import('@/components/BuyModal/PayTopUp.vue'),
  delay: 10000,
})

const PaypalModalAsync = defineAsyncComponent({
  loader: () => import('@/components/BuyModal/PaypalModal.vue'),
  delay: 10000,
})

function init() {
  GlobalThis.$buyModal = buyModalRef.value
  GlobalThis.$loginModalNew = loginModalNewRef.value
  GlobalThis.$LoginPopTips = LoginPopTipsRef.value
  GlobalThis.$postViewModal = postViewRef.value
  GlobalThis.$postViewPhoneModal = postViewPhoneRef.value
  GlobalThis.$musicPlayer = musicPlayerRef.value
  GlobalThis.$globalAlert = globalAlertRef.value
  GlobalThis.$uploadLeaveConfirmModalRef = uploadLeaveConfirmModalRef.value
  GlobalThis.$welcome = welcomeRef.value
  GlobalThis.$getRewards = getRewardsRef.value
  GlobalThis.$insufficientFunds = insufficientFundsRef.value
  GlobalThis.$globalMask = {
    show: () => {
      if (globalMaskRef.value) {
        globalMaskRef.value.style.display = 'block'
      }
    },
    hide: () => {
      if (globalMaskRef.value) {
        globalMaskRef.value.style.display = 'none'
      }
    },
  }
  GlobalThis.$leaveConfirmModal = leaveConfirmModalRef.value
  GlobalThis.$payIframe = payIframeRef.value
  GlobalThis.$creditCardModal = CreditCardModalRef.value
  GlobalThis.$topUpFirst = topUpFirstRef.value
  GlobalThis.$paySuccess = paySuccessRef.value
  GlobalThis.$payTopUp = payTopUpRef.value
  GlobalThis.$paypalModal = paypalModalRef.value
  GlobalThis.$payMask = payMaskRef.value
}
watchPostEffect(() => {
  init()
})
watch(isLogin, () => {
  init()
})
onMounted(() => {
  if (window.requestIdleCallback) {
    window.requestIdleCallback(() => {
      hasInit.value = true
      nextTick(() => {
        init()
      })
    })
  } else {
    setTimeout(() => {
      hasInit.value = true
      nextTick(() => {
        init()
      })
    }, 1000)
  }
})
</script>

<template>
  <GlobalAlert ref="globalAlertRef" />
  <div ref="globalMask" class="global-mask" />
  <LoginModalNewAsync ref="loginModalNewRef" />
  <LoginPopTipsAsync ref="LoginPopTipsRef" />
  <MusicPlayerAsync ref="musicPlayerRef" />
  <template v-if="hasInit && isLogin">
    <BuyModalAsync ref="buyModalRef" />
    <PostViewAsync ref="postViewRef" />
    <PSWPPostViewPhoneAsync ref="postViewPhoneRef" />
    <UploadLeaveConfirmModalAsync ref="uploadLeaveConfirmModalRef" />
    <Welcome ref="welcomeRef" />
    <GetRewards ref="getRewardsRef" />
    <InsufficientFundsAsync ref="insufficientFundsRef" />
    <LeaveConfirmModalAsync ref="leaveConfirmModalRef" />
    <PayIframeAsync ref="payIframeRef" />
    <CreditCardModalAsync ref="CreditCardModalRef" />
    <TopUpFirstAsync ref="topUpFirstRef" />
    <PaySuccessAsync ref="paySuccessRef" />
    <PayTopUpAsync ref="payTopUpRef" />
    <PaypalModalAsync ref="paypalModalRef" />
    <PayMaskAsync ref="payMaskRef" />
  </template>
</template>
